module.exports = __webpack_public_path__ + "img/image001.0f0879ef.jpg";